// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes spinAround-data-v-118be3a9{from{transform:rotate(0deg)}to{transform:rotate(359deg)}}.c-footer[data-v-118be3a9]{background-color:#3e3e3e;color:#fff;padding:24px;font-size:.875rem}@media screen and (min-width: 1044px){.c-footer[data-v-118be3a9]{padding:40px}}.c-footer .columns[data-v-118be3a9]{align-items:flex-end}.c-footer .title[data-v-118be3a9]{color:#fff;margin:0;margin-bottom:16px}\n", ""]);
// Exports
module.exports = exports;
